// extracted by mini-css-extract-plugin
export default {"Tag":"Tag__Tag___RH16C","name":"Tag__name___hgeDu"};